import React from 'react';

import s from './FocusCloseModal.scss';

type ModalView = 'default' | 'full';

export type CloseModalProps = {
  className?: string;
  closeIconClassName?: string;
  isCloseable?: boolean;
  isOpen: boolean;
  onModalClose?: () => void;
  overlayClassName?: string;
  focusOnOpen?: boolean;
  focusOnUpdate?: boolean;
  view?: ModalView;
  shouldCloseOnOverlayClick?: boolean;
  onButtonClick: () => void;
};

class CloseModal extends React.Component<CloseModalProps> {
  closeButtonRef: HTMLButtonElement | null = null;

  constructor(props: CloseModalProps) {
    super(props);
    this.makeRef = this.makeRef.bind(this);
  }

  componentDidMount() {
    if (this.props.focusOnOpen) {
      this.closeButtonRef?.focus();
    }
  }

  componentDidUpdate() {
    if (this.props.focusOnUpdate) {
      this.closeButtonRef?.focus();
    }
  }

  makeRef(el: HTMLButtonElement | null) {
    this.closeButtonRef = el;
  }

  render() {
    return (
      <button
        type="button"
        aria-label="Focus Close Modal"
        ref={this.makeRef}
        id="closeModal"
        onClick={this.props.onButtonClick}
        className={s.button}
      >
        <span className="srOnly">Close Modal</span>
      </button>
    );
  }
}

export default CloseModal;
